import { render, staticRenderFns } from "./LedgerLoader.vue?vue&type=template&id=759020b5&"
import script from "./LedgerLoader.vue?vue&type=script&lang=js&"
export * from "./LedgerLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports